import React, { Component } from 'react'
import { Layout } from '../../widgets'
import * as routes from '../../routes'
import { AdminPlaylistCell } from '../components'
import { NavigationTab, PaginatedList } from '../../components'

class AdminPlaylists extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tab: 'Trending',
    }
  }

  render = () => {
    const tabs = {
      'Trending': <PaginatedList
        key={'trending'}
        loadUrl={routes.adminPlaylistTrendingUrl}
        loadParams={{}}
        featuredUrl={routes.adminPlaylistFeaturedUrl}
        cell={AdminPlaylistCell}
        cellItemPropName={'playlist'}
        datePicker={true}
        featureActionUpdateBehavior={'filter'}
      />,
      'Featured': <PaginatedList
        key={'recently_featured'}
        loadUrl={routes.adminPlaylistFeaturedUrl}
        loadParams={{}}
        featuredUrl={routes.adminPlaylistFeaturedUrl}
        cell={AdminPlaylistCell}
        cellItemPropName={'playlist'}
        featureActionUpdateBehavior={'filter'}
      />,
      'Featured Feed': <PaginatedList
        key={'featured'}
        loadUrl={routes.adminPlaylistFeedUrl}
        loadParams={{'type': 'featured'}}
        featuredUrl={routes.adminPlaylistFeaturedUrl}
        cell={AdminPlaylistCell}
        cellItemPropName={'playlist'}
      />,
    }

    return (
      <div className='body-container'>
        <Layout>
          <Layout.Header>Playlists</Layout.Header>
          <div className='moderator-content'>

            <div className='navigation-tabs'>
              {Object.keys(tabs).map((tab, i) =>
                <NavigationTab
                  key={i}
                  text={tab}
                  isActive={this.state.tab === tab}
                  onClick={() => {
                    if (this.state.tab !== tab) {
                      this.setState({ tab: tab })
                    }
                  }}
                />
              )}
            </div>

            {tabs[this.state.tab]}

          </div>
        </Layout>
      </div>
    )
  }
}

export default AdminPlaylists
